<template>
  <v-btn-form :title="title" @close="cancel()" @enter="refresh()">
      <v-form v-model="valid" ref="form">
       <v-card-text>
          <component
             :is="strategy.viewContentComp(model)"
             >
          </component>
      </v-card-text>
      </v-form>
      </v-card>
    <template #actions>
      <v-btn v-show="model && model.scheduled && !model.started" @click="rollback()">Отменить выполнение</v-btn>
      <v-btn v-show="model && model.resultCode === 'PROCESS'" @click="rollback()">Прервать выполнение</v-btn>
      <v-spacer/>
      <v-btn @click="refresh">Обновить</v-btn>
    </template>
  </v-btn-form>
</template>

<script type="text/javascript">
  import server from '../../api/server'
  import { mapGetters } from 'vuex'
  import vStepGenerator from '../assist/StepGenerator.vue'
  // import people from './index.js'
  import AssistClasses from '../assist/AssistClasses.js'
  import vBtnForm from '../common/BtnForm'

  class Strategy extends AssistClasses.Strategy {
    getTypeCode () {
      return ''
    }
    getTypeName () {
      return ''
    }
    setContext (cxt) {
      this.context = cxt
    }
    createModel () {
      var model = new AssistClasses.Model()
      return model
    }
    createDefaultModel (individual) {
      return this.createModel()
    }
    createModelFromData (data) {
      return this.createModel()
    }
    updateSteps (scheme) {
      return this
    }
    updateModel (model) {
    }
    fetchData (itemId) {
      return new Promise((resolve, reject) => resolve(null))
    }
    updateData (itemId, model) {
      return new Promise((resolve, reject) => resolve(itemId))
    }
    viewTitle (model) {
      return ''
    }
  }

  export default {
    name: 'action-prop',
    components: {vStepGenerator, vBtnForm},
    data: () => ({
      title: '',
      valid: true,
      model: null
    }),
    props: {
      itemId: {
        type: String,
        default: null
      },
      resourceId: {
        type: String,
        default: null
      },
      fullscreen: {
        type: Boolean,
        default: false
      },
      typeCode: {
        type: String,
        default: null
      },
      strategy: {
        type: Object,
        default: () => new Strategy(this)
      }
    },
    created () {
    },
    mounted () {
      this.strategy.setContext(this)
      this.fetchData(this.itemId)
    },
    watch: {
      itemId: function (newVal, oldVal) { // watch it
        this.fetchData(this.itemId)
      },
      strategy: function (newVal, oldVal) { // watch it
        this.strategy = newVal
        this.strategy.setContext(this)
      }
    },
    computed: {
      ...mapGetters({
        getIsMobile: 'getIsMobile',
        calcDialogScroll: 'calcDialogScroll'
      })
    },
    methods: {
       // Model methods
      fetchData (itemId) {
        this.strategy.fetchData(itemId).then(data => {
          this.updateModel(this.strategy.createModelFromData(data))
          this.title = this.strategy.getTypeName()
        })
      },
      updateModel (model) {
        this.$nextTick(() => {
          // console.log('updateModel', model)
          this.model = model
          this.strategy.updateModel(model)
          this.$forceUpdate()
        })
      },
      cancel () {
        this.$emit('close')
      },
      refresh () {
        this.fetchData(this.itemId)
      },
      rollback () {
        const cb = (data) => {
          this.fetchData(this.itemId)
        }
        const cbError = (e) => {
          this.$store.commit('setErrorStatus', {error: e, context: 'Ошибка сервера при отмене действия '})
        }
        server.apiPost(
          '/api/me/action-rollbacks',
          {
            actionCode: this.model.actionCode,
            resourceId: this.itemId
          },
          cb,
          cbError)
      }
    }
  }

</script>




// WEBPACK FOOTER //
// ActionProp.vue?ed94b486